import { Box } from "@mui/material";
import { useAppSelector } from "../../../app/hooks";
import { Nullable } from "../../../common/types/nullable";
import InboxConversationList from "../inbox/InboxConversationList";
import { selectSelectedConversationId } from "../messagingSlice";
import useInboxConversationList from "../useInboxConversationList";
import { ParticipantOption } from "../types/common";
import { Conversation } from "../types/queries";
import FloatingChatConversation from "./FloatingChatConversation";

type Props = {
  participant: Nullable<ParticipantOption>;
  loadMoreConversations: () => void;
  onConversationChange: (conversation: Conversation) => void;
  onAssignedToMe?: () => void;
  onBack: () => void;
};

const FloatingChatPane = ({
  participant,
  loadMoreConversations,
  onConversationChange,
  onAssignedToMe,
  onBack,
}: Props) => {
  const selectedConversationId = useAppSelector(selectSelectedConversationId);
  const { conversations, loading, loadingMore, emptyLabel } =
    useInboxConversationList();

  if (selectedConversationId || participant) {
    return (
      <FloatingChatConversation
        participant={participant}
        onAssignedToMe={onAssignedToMe}
        onBack={onBack}
      />
    );
  }

  return (
    <Box
      data-testid="floating-chat-inbox"
      sx={{ flex: 1, minHeight: 0, height: "100%" }}
    >
      <InboxConversationList
        conversations={conversations}
        loading={loading}
        loadingMore={loadingMore}
        emptyLabel={emptyLabel}
        loadMore={loadMoreConversations}
        onConversationChange={onConversationChange}
      />
    </Box>
  );
};

export default FloatingChatPane;
